<app-button
  variant="ghost"
  class="ord-modal-button-close"
  svgIcon="close"
  ariaLabel="Close"
  [disabled]="loading()"
  (btnClick)="closeDialog()"
/>
<h2 mat-dialog-title class="ord-modal-title">
  <mat-icon
    svgIcon="warn"
    class="ord-icon ord-icon-lg ord-text-yellow"
  ></mat-icon>
  <span>Confirm Cancel</span>
</h2>
<mat-dialog-content class="ord-modal-content">
  <p class="pb-3 font-medium">
    Are you sure you want to cancel this transaction?
  </p>
  <form
    [formGroup]="formGroup"
    (ngSubmit)="handleSubmit()"
    class="grid grid-cols-2 gap-x-4"
  >
    <app-input-textarea
      class="col-span-2"
      id="reason"
      label="Reason"
      controlName="reason"
      placeholder="Enter reason for cancelling this transaction..."
      [validators]="[Validators.required]"
    />
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="ord-modal-actions">
  @if(errorMessages().length > 0) {
  <app-error-list class="ord-modal-errors" [errorMessages]="errorMessages()" />
  }
  <app-button
    variant="secondary"
    [disabled]="loading()"
    (btnClick)="closeDialog()"
  >
    <ng-template appButtonText> Cancel </ng-template>
  </app-button>
  <app-button
    variant="warn"
    [disabled]="loading() || formGroup.invalid"
    [loading]="loading()"
    (btnClick)="handleSubmit()"
  >
    <ng-template appButtonText> Confirm Cancel </ng-template>
  </app-button>
</mat-dialog-actions>
